
import { defineComponent, computed, ref, watch } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import BoundaryInfo from '@/components/layout/BoundaryInfo.vue'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'
import InputGroupDark from '@/components/layout/InputGroupDark.vue'
import JrDatePicker from '@/components/jr-parts/JrDatePicker.vue'
import JrCheckbox from '@/components/jr-parts/JrCheckbox.vue'
import BoundaryStatusEditSend from '@/components/actions/BoundaryStatusEditSend.vue'
import { ElForm } from 'element-plus'
import { boundaryStatusRule } from '@/constants/rules'
import FormItemDisabled from '@/components/layout/FormItemDisabled.vue'
import { dateToString } from '@/services/date'
import Logger from '@/services/logger'

import { useRoute, useRouter } from 'vue-router'
import { BoundaryStatusForm, RequestHeaderBoundaryDetailForm } from '@/types/forms'

/**
 * 境界立会申請件名詳細
 */
export default defineComponent({
  name: 'BoundaryDetail',
  components: {
    DoubleScroll,
    UserLoginWrapper,
    BoundaryInfo,
    JrApplicantTitle,
    InputGroupDark,
    JrCheckbox,
    JrDatePicker,
    BoundaryStatusEditSend,
    FormItemDisabled,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    // 初期値を設定
    const form = ref<BoundaryStatusForm | null>(null)
    const formRef = ref<InstanceType<typeof ElForm>>()
    const requestHeaderId = computed(() => {
      return Number(route.params.request_header_id)
    })
    const detail = ref<RequestHeaderBoundaryDetailForm | null>(null)

    // 申請基本IDチェック
    if (Number.isNaN(requestHeaderId.value)) {
      Logger.info('申請基本IDが正しくない')
      router.push({ name: 'NotFound' })
    }

    watch(
      detail,
      () => {
        if (detail.value && !form.value) {
          form.value = {
            // 境界確認申請受付日
            boundary_confirm_applicant_receipt_date: detail.value.boundary.boundary_confirm_applicant_receipt_date,
            // 調査開始日
            research_start_date: detail.value.boundary.research_start_date,
            // 境界確認書受付日
            boundary_confirm_receipt_date: detail.value.boundary.boundary_confirm_receipt_date,
            // 発送日
            send_date: detail.value.boundary.send_date,
            // 用地管理システム登録日
            land_system_register_date: detail.value.boundary.land_system_register_date,
            // チェックボタン
            boundary_confirm_applicant_receipt_date_checked: detail.value.boundary
              .boundary_confirm_applicant_receipt_date
              ? true
              : false,
            research_start_date_checked: detail.value.boundary.research_start_date ? true : false,
            boundary_confirm_receipt_date_checked: detail.value.boundary.boundary_confirm_receipt_date ? true : false,
            send_date_checked: detail.value.boundary.send_date ? true : false,
            land_system_register_date_checked: detail.value.boundary.land_system_register_date ? true : false,
          }
        }
      },
      { deep: true }
    )

    // *****境界確認申請受付日*****
    watch(
      () => form.value?.boundary_confirm_applicant_receipt_date_checked,
      () => {
        if (form.value) {
          if (
            form.value.boundary_confirm_applicant_receipt_date_checked &&
            !form.value.boundary_confirm_applicant_receipt_date
          ) {
            form.value.boundary_confirm_applicant_receipt_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****調査開始日*****
    watch(
      () => form.value?.research_start_date_checked,
      () => {
        if (form.value) {
          if (form.value.research_start_date_checked && !form.value.research_start_date) {
            form.value.research_start_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****境界確認書受付日*****
    watch(
      () => form.value?.boundary_confirm_receipt_date_checked,
      () => {
        if (form.value) {
          if (form.value.boundary_confirm_receipt_date_checked && !form.value.boundary_confirm_receipt_date) {
            form.value.boundary_confirm_receipt_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****発送日*****
    watch(
      () => form.value?.send_date_checked,
      () => {
        if (form.value) {
          if (form.value.send_date_checked && !form.value.send_date) {
            form.value.send_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    // *****用地管理システム登録日*****
    watch(
      () => form.value?.land_system_register_date_checked,
      () => {
        if (form.value) {
          if (form.value.land_system_register_date_checked && !form.value.land_system_register_date) {
            form.value.land_system_register_date = dateToString(new Date())
          }
        }
      },
      { deep: true }
    )

    return {
      requestHeaderId,
      detail,
      form,
      formRef,
      boundaryStatusRule,
    }
  },
})
